<template>
  <div class="subject-row">
    <div class="tab-block">
      <div class="page-user user" v-if="tabsList && tabsList.length > 0">
        <v-tabs v-model="tab" 
        background-color 
        class="elevation-2 cust-tab"
        :centered="centered"
        :grow="grow"
        :vertical="vertical"
        :right="right"
        :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
        :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
        :icons-and-text="icons">
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            v-for="tabData in tabsList"
            :key="tabData.id"
            :href="'#' + tabData.title"
            @click="onTabChange(tabData)"
            >{{ tabData.title }}</v-tab
          >
          <v-tabs-items :touchless="true" v-model="tab">
            <v-tab-item
              v-for="(tabData, index) in tabsList"
              :key="tabData.id"
              :value="tabData.title"
            >
              <div class="ui-content dashboard">
                <v-card class="mx-auto normal-card autohg">
                  <ChapterTopicList
                    :subject="tabData"
                    :subjects="tabsList"
                    :tab="tabId"
                    :index="index"
                    ref="subject"
                    :checkUncheck="onCheckedUnchecked"
                    :subType="tabData.id"
                    :stepOneData="stepOneData"
                    :stepTwoData="stepTwoData"
                    :stepThreeData="stepThreeData"
                    :stepFourData="stepFourData"
                    :data="tabsList"
                  />
                </v-card>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>
    </div>
    <div
      class="sidebar-block"
      v-if="selectedSubject && selectedSubject.chapters.length"
    >
      <div class="subject-name">{{ tab }}</div>
      <div class="subject-chapter-name-block">
        <div v-for="item in selectedSubject.chapters" :key="item.id">
          <div>
            <div class="sidechaptertopiclistpanel-name" v-if="item.checked && !item.showIndexTopics"> {{ item.title }} </div>
            <div class="chapter-name" v-if="!item.checked && item.showIndexTopics"> {{ item.title }} </div>
          </div>
          <div v-if="item.showIndexTopics" class="topics-name">
            <div v-for="child in item.topic" :key="child.id">
              <div v-if="child.checked" class="topics-title">
                {{ child.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="create-test-block">
      <v-row>
        <v-col cols="12" sm="12" class="create-tst-btn-block create-myt-test-btn">
          <div class="pull-left">
            <v-btn
              v-if="selectedSubject && selectedSubject.chapters.length"
              class="left-btn cust-btn create-tst-btn"
              color="primary"
              @click="createCustomTest(false)"
              >Create Test</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onCloseAlertBox"
      :component="cComponent"
      :status="open"
      :data="customErrorMsg"
    />
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ChapterTopicList from "../components/ChapterTopicList.vue";
import constants from '../../../../utils/constants';
import moment from "moment";

export default {
  name: "MYTPattern",
  props: ["onBackClick", "data", "stepOneData", "stepTwoData","stepThreeData",'stepFourData','stepFiveData','questionType','clearData'],
  components: {
    ChapterTopicList,
  },
  mounted() {
    this.tabsList = this.stepTwoData.selectedSubjects.map(s=>s.value);
    this.defaultData();
    this.checkSessionData();
    this.getSubjectChaptersAndTopics();
  },
  computed: {
  ...mapState("userStore", ["user", "pendingTestList",'myInstitute']),
  },
  data() {
    return {
      tab: null,
      tabsList: [],
      tabId: null,
      subjects: [],
      dataTreeLevel: { subjects: 2, chapter: 3, topic: 4 },

      selectedSubject: {
        id: 1,
        chapters: [
          // { id:1,text: "", checked: false,showIndexTopics:false },
        ],
      },
      selectedChatersTopics: {},
      open: false,
      cComponent: null,
      modalwidth: "1000px",
      customErrorMsg: "",      
      icons: false,
      centered: false,
      grow: false,
      vertical: false,
      prevIcon: false,
      nextIcon: false,
      right: false,
    };
  },
  methods: {
    ...mapActions({
      getMYTRefData: "utilStore/getMYTRefData",
      getSubTypeList: "utilStore/getSubTypeList",
      setQuestions: "questionStore/setQuestions",
      setQuestionsTypeList: "questionStore/setQuestionsTypeList",
      getMYTDataTree: "utilStore/getMYTDataTree",
      createMytTest: "testStore/createMytTest",
    }),
    defaultData() {
      // let routeName = this.$route.name;
      // this.subjects = this.stepOneData.selectedSubjects;
      // let crd = this.getCurrentRouteDetails(routeName);
      // if (crd) {
        this.tab = this.tabsList[0].title;
      // }
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {};
        this.tabsList.map((t) => {
          tabDetail[t.title] = {
            page: 1,
            orderBy: {
              field: "test_name",
              order: "ASC",
            },
          };
        });
        let routeDetails = {
          routeName: rp.name,
          selectedTab: this.tab,
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
    },
    onTabChange(tab) {
      this.tabId = tab;
      this.selectedSubject = tab;
    },

    getSubjectChaptersAndTopics() {
      let tabData = [],
      length = this.tabsList.length;
		let question_type = [];
    if(this.data && this.data.data){
      if(this.data.data.questionList && this.data.data.questionList.length){
        this.data.data.questionList.map((q) => {
          if (!question_type.includes(q.question_type)) {
            question_type.push(q.question_type)
          }
        })
      }
    }
      this.$root.showLoader = true;
      this.tabsList.map((t) => {
        let reqData = {
          parentIds: this.getSubjectId(t),
		      question_type: question_type.join(","),
          sub_subject:this.checkBiology(t)? t.code : "",
          creator_id: this.user ? this.user.id.toString(): localStorage.getItem('guest_user_id'),
          target_exam:this.stepOneData.targetSelected.target_exam_id,
        };
        this.getMYTDataTree(reqData)
          .then((response) => {
            t = {
				      sort_by:t.sortBy,
              ...response.tree,
              title:t.title,
              id:t.id
            };
            let chapters = [];
            t.children && t.children.map((c) => {
              if (c.is_add_btn === 0) {
                // console.log(c);

                let topics = [];

                let h = {
                  ...c,
                  checked: false,
                  showTopics: false,

                  showIndexTopics: false,
                  parent:t.id
                };
                c.children && c.children.length > 0
                  ? c.children.map((p) => {
                      if (p.is_add_btn === 0) {
                        let x = { ...p };
                        x.checked = false;
                        topics.push(x);
                      }
                    })
                  : [],
                  (h.topic = topics);
                delete h.children;

                chapters.push(h);
              }
            });
            t.chapters = chapters;
            delete t.children;

            this.selectedChatersTopics[t.title] = {
              selectedChapters: [],
              selectedTopics: [],
            };

            tabData.push(t);

            if (tabData.length === length) {
				this.$root.showLoader = false;
				tabData.sort(function (a, b) {	
					return a.sort_by - b.sort_by
    	        })
			  this.selectedSubject =  this.tabsList[0];
			  this.tab = tabData[0].title;
            }
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      });
      this.tabsList = tabData;

    },
    onCheckedUnchecked(item) {
      let sIndex = -1;
      if (item.level === this.dataTreeLevel.chapter) {
        sIndex = this.tabsList.findIndex((t) => t.id === item.parent);
      } else if (item.level === this.dataTreeLevel.topic) {
        sIndex = this.tabsList.findIndex((t) => {
          const sub = t.chapters.find((x) => {
            if (x.id === item.parent) {
              return x;
            }
          });
          if (sub) {
            return t.id === sub.parent;
          }
        });
      }
      if (item.checked) {
        if (item.level === this.dataTreeLevel.chapter) {
          let index = this.tabsList[sIndex].chapters.findIndex(
            (c) => c.id === item.id
          );
          this.tabsList[sIndex].chapters[index].topic.map(
            (t) => (t.checked = true)
          );
          this.tabsList[sIndex].chapters[index].showIndexTopics = false;
          if (
            !this.selectedChatersTopics[
              this.tabsList[sIndex].title
            ].selectedChapters.includes(item.id)
          ) {
            this.selectedChatersTopics[
              this.tabsList[sIndex].title
            ].selectedChapters.push(item.id);
            this.tabsList[sIndex].chapters[index].topic.map((t) => {
              let i = this.selectedChatersTopics[
                this.tabsList[sIndex].title
              ].selectedTopics.indexOf(t.id);
              if (i >= 0) {
                this.selectedChatersTopics[
                  this.tabsList[sIndex].title
                ].selectedTopics.splice(i, 1);
              }
            });
			
          }
		  this.tabsList[sIndex].chapters[index].topic.map(t=>{
				 this.selectedChatersTopics[
                  this.tabsList[sIndex].title
                ].selectedTopics.push(t.id)
			})
        } else if (item.level === this.dataTreeLevel.topic) {
          let index = this.tabsList[sIndex].chapters.findIndex(
            (c) => c.id === item.parent
          );
          if (
            !this.selectedChatersTopics[
              this.tabsList[sIndex].title
            ].selectedTopics.includes(item.id)
          ) {
            this.selectedChatersTopics[
              this.tabsList[sIndex].title
            ].selectedTopics.push(item.id);
            this.tabsList[sIndex].chapters[index].showIndexTopics = true;
          }
          const filteredSubjects = this.tabsList[sIndex].chapters[
            index
          ].topic.filter((o) => o.checked === true);

          let isChecked =
            filteredSubjects.length ===
            this.tabsList[sIndex].chapters[index].topic.length;

          if (isChecked) {
            this.tabsList[sIndex].chapters[index].checked = true;
            this.tabsList[sIndex].chapters[index].showIndexTopics = false;
            // this.tabsList[sIndex].chapters[index].topic.map((t) => {
            //   let i = this.selectedChatersTopics[
            //     this.tabsList[sIndex].title
            //   ].selectedTopics.indexOf(t.id);
            //   if (i >= 0) {
            //     this.selectedChatersTopics[
            //       this.tabsList[sIndex].title
            //     ].selectedTopics.splice(i, 1);
            //   }
            // });
            if (
              !this.selectedChatersTopics[
                this.tabsList[sIndex].title
              ].selectedChapters.includes(item.parent)
            ) {
              this.selectedChatersTopics[
                this.tabsList[sIndex].title
              ].selectedChapters.push(item.parent);
            }
          }else{
			  if (
              !this.selectedChatersTopics[
                this.tabsList[sIndex].title
              ].selectedChapters.includes(item.parent)
            ) {
              this.selectedChatersTopics[
                this.tabsList[sIndex].title
              ].selectedChapters.push(item.parent);
            }
		  }
        }
      } else {
        if (item.level === this.dataTreeLevel.chapter) {
          let jindex = this.tabsList[sIndex].chapters.findIndex(
            (c) => c.id === item.id
          );
          this.tabsList[sIndex].chapters[jindex].topic.map((t) => {
            t.checked = false;
          });
          this.tabsList[sIndex].chapters[jindex].topic.map((t) => {
            let i = this.selectedChatersTopics[
            this.tabsList[sIndex].title
          ].selectedTopics.indexOf(t.id);
            if (i>-1) {
              this.selectedChatersTopics[
                this.tabsList[sIndex].title
              ].selectedTopics.splice(i, 1);
              
            }
          });
		  this.tabsList[sIndex].chapters[jindex].showIndexTopics = false;
          let i = this.selectedChatersTopics[
            this.tabsList[sIndex].title
          ].selectedChapters.indexOf(item.id);
          this.selectedChatersTopics[
            this.tabsList[sIndex].title
          ].selectedChapters.splice(i, 1);
        } else if (item.level === this.dataTreeLevel.topic) {
          let index = this.tabsList[sIndex].chapters.findIndex(
            (c) => c.id === item.parent
          );
          let j = this.tabsList[sIndex].chapters[index].topic.findIndex(
            (c) => c.id === item.id
          );
          let isChecked = this.tabsList[sIndex].chapters[index].topic.some(
            (t) => t.checked === false
          );
          this.tabsList[sIndex].chapters[index].topic[j].checked = false;
          if (!isChecked) {
            this.tabsList[sIndex].chapters[index].checked = false;
            this.tabsList[sIndex].chapters[index].showIndexTopics = true;
          }
          this.tabsList[sIndex].chapters[index].topic.map((x) => {
            if (
              x.checked &&
              !this.selectedChatersTopics[
                this.tabsList[sIndex].title
              ].selectedTopics.includes(x.id)
            ) {
              this.selectedChatersTopics[
                this.tabsList[sIndex].title
              ].selectedTopics.push(x.id);
            } else if (
              !x.checked &&
              this.selectedChatersTopics[
                this.tabsList[sIndex].title
              ].selectedTopics.includes(x.id)
            ) {
              let i = this.selectedChatersTopics[
                this.tabsList[sIndex].title
              ].selectedTopics.indexOf(x.id);
              if (i >= 0) {
                this.selectedChatersTopics[
                  this.tabsList[sIndex].title
                ].selectedTopics.splice(i, 1);
              }
            }
          });
          let i = this.selectedChatersTopics[
            this.tabsList[sIndex].title
          ].selectedChapters.indexOf(item.parent);

          let found = this.tabsList[sIndex].chapters[index].topic.some(
            (t) => t.checked === true
          );
          if (i >= 0 && !found) {
            this.selectedChatersTopics[
              this.tabsList[sIndex].title
            ].selectedChapters.splice(i, 1);
          }
          if (!found) {
            this.tabsList[sIndex].chapters[index].showIndexTopics = false;
          }
        }
      }
      this.selectedSubject = this.tabsList[sIndex];
    },
    createCustomTest(confirmation = false) {
      if (this.validtaion()) {
        
        let stepOneData = this.stepOneData;
        this.$root.showLoader = true;
        let questionTypes = this.questionType;
        // let list = [];
        // let forUpdate = false;
        let myInstitute = JSON.parse(localStorage.getItem("myInstitute"));
      let creatorId = localStorage.getItem('guest_user_id');
      let userData = JSON.parse(sessionStorage.getItem('user'))
        let { questionList, optionalQuestionsList } = this.data.data;
        //questionList = this.getQuestionArray(questionList);
        let {list,forUpdate} = this.createTestData({questions:questionList,optionalQuestionsList,selectedChatersTopics:this.selectedChatersTopics},confirmation,true)
      let isOnline = localStorage.getItem('isOnlineTest')
  
        let reqData = {
          list: list,
        target_exam: stepOneData.targetSelected.target_exam_id,
        test_type: stepOneData.testType
          ? stepOneData.testType
          : this.TEST_TYPE.CUSTOM,
        duration: 60,
        test_name: stepOneData.testName,
        optionalQuestionsList: optionalQuestionsList,
        is_online_test: isOnline === "Online" ? 1 : 0,
        // institute_id: myInstitute.id,
        institute_id: myInstitute.id,
        creator_id:userData?userData.id.toString():creatorId,
        };
        if (forUpdate) {
          reqData.only_question = true;
        }
        if (stepOneData.testId) {
          reqData.id = stepOneData.testId;
        }
        if (confirmation) {
          reqData.allowed_dummy_question = true;
        }
        this.createMytTest(reqData)
          .then((response) => {
            let subjectCustomMsg = [];
  
            if (response.code === 204) {
              let subject = "";
              response.list.map((s) => {
                subjectCustomMsg.push(
                  `${s.required_dummy_questions} questions of ${s.sub_type?
                  questionTypes.find((q) => q.value.id === s.sub_type)
                    .text:questionTypes.find((q) => q.value.id === s.question_type_id)
                    .text
                } from  ${
                    this.stepTwoData.selectedSubjects.find(
                      (sub) => sub.value.id === s.subject_id || sub.value.code === s.sub_subject
                    ).text
                  }`
                );
              });
              this.customErrorMsg = subjectCustomMsg;
              this.cComponent =
                "views/pages/mytuser/components/customizedMYTTestAlertBox";
              this.modalwidth = "500px";
              this.open = true;
            } else {
              this.$toasted.success(`Success\n${response.msg}`, {
                icon: "check_circle",
              });
              // if (forUpdate) {
              //   this.onClose({
              //     status: false,
              //     reloadPreview: true,
              //   });
              // } else {
              //   this.$router.push({ name: "customized-tests-myt" });
              // }
              this.clearData()
            }
            this.disableCreateTest = false;
  
            this.$root.showLoader = false;
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      }
    },
    onCloseAlertBox(data) {
      this.open = data.status;
      if (data.confirm) {
        this.createCustomTest(data.confirm);
      }
    },
    validtaion(){
      let valid = true;
      for (let [key, value] of Object.entries(this.selectedChatersTopics)) {
        if (value.selectedChapters && value.selectedChapters.length===0 && value.selectedTopics && value.selectedTopics.length===0) {
          this.$toasted.error(`${key} syllabus is not selected`);
          valid=false;
        }
      }
      return valid
    },
  },
  watch: {
    tab(val, oldVal) {
      if (oldVal) {
        // only when tab is changed and not on page load
        let routeName = this.$route.name;
        this.setRouteDetails({ routeName, selectedTab: val });
      }
    },
  },
};
</script>
